import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import LoadingImage from "../../../comum/components/LoadingImage";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CollapseItemTableIndicator } from "../../../comum/components/CollapseItemTableIndicator";
import DetalhesNotaFiscalFaturamento from "./DetalhesNotaFiscalFaturamento";
import { Col, Container, Row } from "reactstrap";
import { buscaFiltrarVazio } from "../../../../utils/mensagens";
import Card from "../../../comum/components/Card";
import TabelaNotaFiscalItemFaturamento from "./TabelaNotaFiscalItemFaturamento";

@inject("store")
@observer
export default class TabelaNotaFiscalFaturamento extends Component {
  constructor(props) {
    super(props);
    this.controller = this.props.controller;
  }

  splitEmails(emails) {
    const retorno = emails.split(",").map(e => e.trim());
    return retorno;
  }

  render() {
    const colunasAnexosFaturamento = this.controller.colunasAnexosFaturamento;
    let lista =
      this.controller.dadosConsulta && this.controller.dadosConsulta.length > 0
        ? this.controller.dadosConsulta
        : [];
    let loading = this.controller.loading;
    const qtdeDados = lista.length;

    //Se a lista tiver somente um resultado, mostrar a row de detalhes já expandida.
    let toExpand = null;
    if (lista.length === 1) {
      toExpand = lista[0].Id;
    }

    const detalhesRow = {
      renderer: row => (
        <Row>
          <Col xl={12} lg={12} sm={"auto"} xs={6} className="container-card-detalhe-anexos">
            <div>
              {process.env.rig && (
                <Fragment>
                  <h4>Itens</h4>
                  <TabelaNotaFiscalItemFaturamento controller={this.controller} notaId={row.Id} />
                  <br />
                </Fragment>
              )}
              <h4>Documentos</h4>
              <Row className="ml-1 d-flex mb-1">
                <DetalhesNotaFiscalFaturamento controller={this.controller} notaId={row.Id} />
              </Row>

              {process.env.rig && (
                <Fragment>
                  {
                    row.Status === 2 &&
                    <Card className="mx-0 px-0 mb-2">
                      <div className="ml-2">
                        <h4>
                          <strong>Instruções para Atualização de Boleto</strong>
                        </h4>
                      </div>
                      <div>
                        <ul className="mensagem-filtrar mt-1">
                          <li>
                            - Acessar o Link <a href="https://www.itau.com.br/servicos/boletos/atualizar/index.html?ef_id=CjwKCAjwlrqHBhByEiwAnLmYUMcrzYbl4OAI932vgP5Lyn--n8cby9tV8a0f3x2lupOLWo-lp7s19xoCjVMQAvD_BwE:G:s&s_kwcid=AL!905!3!!!!x!!&gclid=CjwKCAjwlrqHBhByEiwAnLmYUMcrzYbl4OAI932vgP5Lyn--n8cby9tV8a0f3x2lupOLWo-lp7s19xoCjVMQAvD_BwE" target="_blank">
                            https://www.itau.com.br/servicos/boletos/atualizar/index.html;
                          </a>
                          </li>
                          <li>- Selecione a opção "Itaú";</li>
                          <li>- Preencher informações solicitadas e digitar a numeração do código de barras do boleto vencido nos campos indicados;</li>
                        </ul>
                        <span
                          className="ml-2 label-black"
                          style={{ paddingLeft: "30px" }}
                        >
                          {" "}
                          * ATENÇÃO: Todo boleto vencido, quando atualizado, tem seu vencimento programado para a data base do dia em que é atualizado.
                      </span>
                      </div>
                    </Card>
                  }
                  <Card className="mx-0 px-0">
                    <div className="ml-2">
                      <h4>
                        <strong>Atualização de Email(s)</strong>
                      </h4>
                    </div>
                    <div>
                      <ul className="mensagem-filtrar mt-1">
                        <li>Os Emails cadastrados estão desatualizados ?</li>
                        {row.EmailContato && row.EmailContato.split(",").map(e => e.trim())
                          .map(e => (<li style={{ letterSpacing: "0.1em" }}>- <a href={"mailto:" + e}>{e} </a></li>))}
                        <li>Se sim, favor enviar solicitação para atualização de cadastros ao email atendimento.tcrg@wilsonsons.com.br com o Assunto "Atualização de cadastros -Cliente-";</li>
                        <li>- Informar até 03 emails com domínio do próprio cliente que deverão receber as documentações dos faturamentos; </li>
                      </ul>
                      <span
                        className="ml-2 label-black"
                        style={{ paddingLeft: "30px" }}
                      >* Lembre-se: É imprescindível fornecer as informações abaixo: </span>
                      <ul className="mensagem-filtrar mt-1 mb-0">
                        <li>- Confirmar todos os CNPJs que operam com o Tecon Rio Grande S/A;</li>
                        <li>- Informar até 03 emails com domínio do próprio cliente que deverão receber as documentações dos faturamentos;</li>
                      </ul>
                    </div>
                  </Card>
                  <h4 className="mt-2">* Notas À Vista não possuem Protocolo.</h4>
                </Fragment>
              )}
            </div>
          </Col>
        </Row>
      ),
      expanded: [toExpand],
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: () => "Detalhes",
      expandColumnPosition: "right",
      expandByColumnOnly: true,
      onExpandAll: (isExpandAll, results, e) => {
        e.PreventDefault();
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return <CollapseItemTableIndicator expanded={expanded} />;
        }
        return <CollapseItemTableIndicator expanded={expanded} />;
      }
    };

    return (
      <div>
        <Container fluid className="tabela-container">
          {!this.controller.filtrado ? (
            <Row>
              <Col className="mt-3" xs={12}>
                <span className="mensagem-filtrar">{buscaFiltrarVazio}</span>
              </Col>
            </Row>
          ) : (
              <ToolkitProvider
                keyField="Id"
                data={lista.slice()}
                columns={[...this.controller.colunasNotaFaturamento]}
              >
                {props => (
                  <div>
                    {window.innerWidth > 991 ? (
                      <BootstrapTable
                        bootstrap4
                        striped
                        bordered={false}
                        noDataIndication={() =>
                          loading ? (
                            <LoadingImage />
                          ) : (
                              this.controller.filtrado &&
                              this.controller.tableMessage
                            )
                        }
                        classes="tabela"
                        expandRow={detalhesRow}
                        pagination={paginationFactory()}
                        defaultSorted={[
                          {
                            dataField: "Numero",
                            order: "desc"
                          }
                        ]}
                        {...props.baseProps}
                      />
                    ) : (
                        <Row>
                          <div />
                        </Row>
                      )}
                  </div>
                )}
              </ToolkitProvider>
            )}
        </Container>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/notafiscal/components/TabelaNotaFiscalFaturamento.js